export default __webpack_public_path__ + "static/media/kit_4.9aac41ee.png";